import { render, staticRenderFns } from "./ModalEscolhaPermissao.vue?vue&type=template&id=f4309992&scoped=true&"
import script from "./ModalEscolhaPermissao.vue?vue&type=script&lang=js&"
export * from "./ModalEscolhaPermissao.vue?vue&type=script&lang=js&"
import style0 from "./ModalEscolhaPermissao.vue?vue&type=style&index=0&id=f4309992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4309992",
  null
  
)

export default component.exports